module.exports = __webpack_public_path__ + "static/media/7client.ddfaa281.png";